export const deriveIsRequest = (
  facility?: {
    club?: {
      supportsPrivate?: boolean | null;
    } | null;
    privateLessonsPermissionSet?: {
      patronAccess?: "BOOKING" | "REQUEST" | "NONE" | null;
    } | null;
    publicLessonsPermissionSet?: {
      patronAccess?: "BOOKING" | "REQUEST" | "NONE" | null;
    } | null;
  } | null
): boolean => {
  if (!facility) return false;
  const isPrivate = facility.club?.supportsPrivate ?? false;

  if (isPrivate) {
    return facility.privateLessonsPermissionSet?.patronAccess === "REQUEST";
  }
  return facility.publicLessonsPermissionSet?.patronAccess === "REQUEST";
};
